var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconHome = function SvgIconHome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dock",
    transform: "translate(-28.000000, -93.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1068-Copy",
    transform: "translate(28.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7777,0.3223 C11.3476,-0.1078 10.6524,-0.1078 10.2223,0.3223 L0.3223,10.2223 C0.0077,10.5369 -0.0869,11.0099 0.0836,11.4213 C0.2541,11.8327 0.6556,12.1 1.1,12.1 L3.3,12.1 L3.3,20.9 L8.8,20.9 L8.8,15.4 L13.2,15.4 L13.2,20.9 L18.7,20.9 L18.7,12.1 L20.9,12.1 C21.3444,12.1 21.7459,11.8327 21.9164,11.4213 C22.0869,11.0099 21.9923,10.5369 21.6777,10.2223 L11.7777,0.3223 Z",
    id: "Fill-1068"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-home.20ef7609f71576f49e802e84504fcde8.svg";